import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineWrite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.375 1.7H1.7c-.58 0-1.05.47-1.05 1.05v9.45c0 .58.47 1.05 1.05 1.05h9.45c.58 0 1.05-.47 1.05-1.05V8.525"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m7.472 9.01-3.149.565.525-3.177L10.337.959a1.05 1.05 0 0 1 1.49 0l1.112 1.108a1.045 1.045 0 0 1 0 1.484z"
    />
  </svg>
);
export default SvgStreamlineWrite;
